
























import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";

export default Vue.extend({
  components: {
    Modal,
  },
  data(): { config: ModalConfig } {
    return {
      config: {
        title: "",
        desc: "",
        blank: true,
        width: "36rem",
        withTopRightCloseBtn: true,
      },
    };
  },
});
